<c-modal #staticBackdropModal backdrop="static" size="lg" visible='true' id="staticBackdropModal">
    <c-modal-header>
        <h4 class="modal-title">{{ "Monthly Revenues Per Item" }}</h4>
        <button [cModalToggle]="staticBackdropModal.id" cButtonClose (click)="closeModal()" title="Close"></button>
    </c-modal-header>
    <c-modal-body *ngIf="isMonthlyRevenuesPerItemLoaded && filteredMonthlyRevenuesPerItem">
      <c-row [xs]="1" [xl]="2">
        <c-col>
          <c-card class="mb-4">
            <c-card-header>Year & Month</c-card-header>
            <c-card-body>
              <c-row>
                <c-col>
                  <c-row>
                    Year: {{selectedYear}}, Month: {{selectedMonth}}
                  </c-row>
                </c-col>
              </c-row>
            </c-card-body>
          </c-card>
        </c-col>
      </c-row>
      <c-row [xs]="1" [xl]="1">
        <c-col>
          <c-card class="mb-4">
            <c-card-header>Items List</c-card-header>
            <c-card-body>
                <c-row>
                  <table cTable hover>
                    <thead>
                    <tr>
                      <th scope="col">Item Name</th>
                      <th scope="col">Total Revenues</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let item of filteredMonthlyRevenuesPerItem">
                      <td>{{item.item_name}}</td>
                      <td>{{item.total}}</td>
                    </tr>
                    </tbody>
                    <tfoot cTableColor="dark">
                      <tr>
                        <td scope="col"><strong>Total</strong></td>
                        <td scope="col"><strong>{{totalMonthlyRevenue}}</strong></td>
                      </tr>
                    </tfoot>
                  </table>
                </c-row>
            </c-card-body>
            <c-modal-footer>
              <button cButton color="secondary" (click)="closeModal()">Close</button>
              <button cButton color="primary" (click)="exportMonthlyRevenuesPerItemReport()">Export</button>
            </c-modal-footer>
          </c-card>
        </c-col>
      </c-row>
    </c-modal-body>
</c-modal>
